<template>
  <div
    v-if="isshow"
    class="tag-list"
  >
    <div
      v-if="showTagBox"
      ref="tagBox"
      class="tag tag-box"
      :class="isMac? 'mac': ''"
      :style="{'width': tagBoxWidth + 'px'}"
    >
      <i class="tag-flag" />
      <ul
        ref="tagShow"
        class="taglist-box"
        @click.stop=""
      >
        <li
          v-for="({name, id, type}, index) in tags"
          :key="index"
          :ref="searchTarget(name) ? 'targetTag' : 'normalTag'"
          :title="name"
          :class="{filter: id == tagid, disabled: tagging, dlp: type == 1}"
          :data-tag-id="id"
          class="tag-item"
        >
          <div
            :ref="`tag-${index}`"
            class="high-light"
            :class="{
              'search-target': searchTarget(name),
              'need-min-width': index === 0 && !showTagBox,
              'dlp': type == 1
            }"
            v-html="isSearchTarget(name)"
          />
        </li>
        <span
          :class="{'icon-caret_down': !showTagBox,'icon-caret_up': showTagBox, 'icon-box':true}"
          @click.stop="changeTagBox"
        />
      </ul>
    </div>
    <div
      v-else
      class="tag"
      :class="{'tagShow': isshow, 'mac': isMac,'isSafari': isSafari}"
    >
      <ul ref="tagShow">
        <li class="tag-flag-container">
          <i class="tag-flag" />
        </li>
        <li
          v-for="({name, originName, id, type}, index) in tags"
          :key="index"
          :ref="searchTarget(name) ? 'targetTag' : 'normalTag'"
          :title="originName || name"
          :class="{filter: id == tagid, disabled: tagging, dlp: type == 1}"
          :data-tag-id="id"
          class="tag-item"
        >
          <div
            :ref="`tag-${index}`"
            class="high-light"
            :class="{
              'search-target': searchTarget(name),
              'need-min-width': index === 0 && !showTagBox,
              'dlp': type == 1
            }"
            v-html="isSearchTarget(name)"
          />
        </li>
        <span
          v-if="showIconDown"
          :class="{'icon-caret_down': !showTagBox,'icon-caret_up': showTagBox, 'icon-box':true}"
          @click.stop="changeTagBox"
        />
      </ul>
    </div>
    <div
      v-if="showTagBox"
      style="height:21px"
    />
  </div>
</template>
<script>
import { isMac, isSafari } from 'util/util'

export default {
  props: {
    tagInfo: {
      type: Array,
    },
    neLabel: {
      type: Array,
    },
  },
  data() {
    return {
      showIconDown: false, // 三角icon的显示隐藏
      showTagBox: false, // 标签浮层框的显示隐藏
      tagBoxWidth: '', // 标签浮层框的宽度
      isMac: isMac(),
      isSafari: isSafari(),
    }
  },
  computed: {
    tags() {
      return this.tagInfo
    },
    tagLength() {
      return this.tagInfo.length
    },
    isshow() {
      return this.tags.length > 0
    },
    tagid() {
      const { $route } = this
      const { name } = $route
      if (name.indexOf('tag') < 0) return NaN
      return $route.query.id
    },
    searching() {
      const route = this.$route
      return /\w*-search/.test(route.name)
    },
    tagging() {
      const route = this.$route
      return route.path.split('/').pop() === 'tag'
    },
    searchParam() {
      return this.$store.state.HeaderButtonState.searchParam
    },
  },
  watch: {
    showTagBox(value) {
      if (value) {
        document.body.addEventListener('click', this.changeTagBox)
      } else {
        document.body.removeEventListener('click', this.changeTagBox)
      }
    },
    tagLength: {
      handler(newVal) {
        if (newVal) {
          this.changeShowIconDown()
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.isshow) {
      this.changeShowIconDown()
    }
  },
  methods: {
    closeTags() {
      this.showTagBox = false
    },
    changeTagBox() {
      this.tagBoxWidth = this.$refs.tagShow && this.$refs.tagShow.offsetWidth - 8
      this.showTagBox = !this.showTagBox
      if (this.showTagBox && this.$refs.targetTag) {
        this.$nextTick(() => {
          const targetTags = this.$refs.targetTag
          const targetTagWidth = targetTags.map((item) => item.offsetWidth)
          const maxWidth = Math.max(...targetTagWidth)
          if (maxWidth > this.tagBoxWidth) {
            this.tagBoxWidth = maxWidth + 16
          }
        })
      }
    },
    changeShowIconDown() {
      this.$nextTick(() => {
        this.changeIconDown()
        window.removeEventListener('resize', this.changeIconDown)
        window.addEventListener('resize', this.changeIconDown)
      })
    },
    changeIconDown() {
      if (this.$refs.tagShow
        && this.$refs.tagShow.offsetHeight
        && this.$refs.tagShow.offsetHeight > 25) {
        this.showIconDown = true
      } else {
        if (
          this.$refs['tag-0']
          && this.$refs['tag-0'].length > 0
        ) {
          const tag = this.$refs['tag-0'][0]
          const tagClass = tag.className
          if (tagClass.indexOf('search-target') > -1) {
            const tagScrollWid = tag.scrollWidth
            const tagBoxWidth = this.$refs.tagShow && this.$refs.tagShow.offsetWidth - 8
            if (tagScrollWid > tagBoxWidth) {
              this.showIconDown = true
              return
            }
            tag.classList.remove('need-min-width')
          }
        }
        this.showIconDown = false
      }
    },
    searchTarget(tagNameParma) {
      const tagName = tagNameParma
      if (!tagName) return false
      if (this.searching || this.tagging || this.neLabel) {
        let len = this.neLabel.length
        const regx = /<[^>]*>|<\/[^>]*>/gm
        while (len > 0) {
          len -= 1
          const tempLabel = this.neLabel[len].replace(regx, '')
          if (tempLabel === tagName) {
            return true
          }
        }
      }
      return false
    },
    isSearchTarget(tagNameParma) {
      const tagName = tagNameParma
      if (!tagName) return
      if (this.searching || this.tagging || this.neLabel) {
        let len = this.neLabel.length
        const regx = /<[^>]*>|<\/[^>]*>/gm
        while (len > 0) {
          len -= 1
          const tempLabel = this.neLabel[len].replace(regx, '')
          if (tempLabel === tagName) {
            return this.neLabel[len].replace(/\s/g, '&nbsp;')
          }
        }
      }
      return tagName.replace(/\s/g, '&nbsp;')
    },
  },
}
</script>
<style lang="less" scoped>
.tag-list {
  line-height: normal;
}
.tag{
  position: relative;
  &.tagShow{
    height: 21px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: height 0.5s;
    -moz-transition: height 0.5s; /* Firefox 4 */
    -webkit-transition: height 0.5s; /* Safari 和 Chrome */
    -o-transition: height 0.5s; /* Opera */
  }
  &.tag-box{
    padding: 4px 4px 0 4px;
    margin-bottom: 2px;
    position: absolute;
    overflow:unset;
    z-index: 1000;
    background:#FFFFFF;
    box-shadow: 0 1px 6px 0 rgba(0,0,0,0.14);
    ul{
      margin-left: 18px;
      margin-top: -20px;
    }
    .tag-flag{
      margin-bottom: 0;
    }
  }
  ul {
    white-space: pre-wrap;

    li {
      display: inline-block;

      .dlp {
        /* 预留给dlp标签 */
        border: 1px solid #67707c;
        padding: 0 5px;
      }
    }
  }

  .tag-flag-container {
    position: relative;
    width: 14px;
    height: 20px;
    box-sizing: border-box;
    float: left;

    .tag-flag {
      position: absolute;
      top: 50%;
      margin-top: -9px;
    }
  }

  .tag-flag {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url(~image/file-operate-tag.svg) no-repeat;
  }

  .icon-box {
    cursor: pointer;
    position: absolute;
    right: 4px;
    top: 4px;
  }

  .tag-item {
    position: relative;
    display: inline-block;
    height: 20px;
    color: #637282;
    padding: 0 8px;
    margin-left: -5px;
    &.filter {
      color: #ed8913;
    }
    &.disabled .high-light{
      cursor: default;
    }

    & + .tag-item::before {
      content: '|';
      position: absolute;
      left: 0px;
      display: inline-block;
      font-size: 12px;
      color: #c6cdd7;
    }

    .high-light {
      font-size: 12px;
      overflow: hidden;
      max-width: 100px;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 20px;
      box-sizing: border-box;
      line-height: 18px;
      cursor: pointer;
      &.search-target:not(.need-min-width) {
        max-width: none;
      }
    }
  }
}
</style>
